module.exports = __webpack_public_path__ + "static/media/success-icon.77077420.svg";